import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "orgteam-bar" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  style: {"margin-bottom":"14px"}
}
const _hoisted_5 = { class: "orgwrap" }
const _hoisted_6 = { class: "tree-ul" }
const _hoisted_7 = { class: "acct-zoom" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 2,
  style: {"margin":"20px 0","color":"#a8a4a0"}
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  style: {"margin":"20px 0","color":"#a8a4a0"}
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "error-msg-wrap"
}
const _hoisted_15 = { class: "form-wrapper slide-up" }
const _hoisted_16 = { class: "form-close" }
const _hoisted_17 = { style: {"margin-bottom":"15px","text-decoration":"underline"} }
const _hoisted_18 = {
  key: 1,
  class: "error-msg-wrap"
}
const _hoisted_19 = {
  class: "form-wrapper slide-up",
  style: {"width":"1100px","max-width":"95%"}
}
const _hoisted_20 = { class: "form-close" }
const _hoisted_21 = { style: {"margin-top":"0"} }
const _hoisted_22 = { class: "acct-editor-body" }
const _hoisted_23 = { class: "acct-add-row" }
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  key: 0,
  class: "acct-cycle-banner"
}
const _hoisted_26 = {
  key: 1,
  class: "acct-roster-list"
}
const _hoisted_27 = { class: "acct-ini" }
const _hoisted_28 = { class: "acct-who" }
const _hoisted_29 = { class: "acct-n" }
const _hoisted_30 = { class: "acct-t" }
const _hoisted_31 = ["onChange"]
const _hoisted_32 = ["selected"]
const _hoisted_33 = ["value", "selected"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 2,
  class: "acct-roster-empty"
}
const _hoisted_36 = { style: {"overflow":"auto"} }
const _hoisted_37 = { class: "acct-editor-preview" }
const _hoisted_38 = {
  key: 0,
  class: "tree acct-flip"
}
const _hoisted_39 = { class: "tree-ul" }
const _hoisted_40 = {
  key: 1,
  class: "acct-roster-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_accountability_chart_node = _resolveComponent("accountability-chart-node")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_phone_input = _resolveComponent("phone-input")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "page-bar" }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Team"),
        _createElementVNode("div", { class: "page-bar-main" }, "Accountability Chart")
      ])
    ], -1)),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide'),
      style: {"padding-bottom":"0"}
    }, [
      (_ctx.charts.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.charts, (c, i) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: i,
                  type: "button",
                  class: _normalizeClass(["orgteam-btn", { on: _ctx.selectedChartID == c.ID }]),
                  onClick: ($event: any) => (_ctx.selectChart(c.ID))
                }, _toDisplayString(c.Name), 11, _hoisted_3))
              }), 128)),
              (_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.newChart())),
                    type: "button",
                    class: "orgteam-btn on",
                    style: {"pointer-events":"auto"}
                  }, "New Chart"))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.shareChart())),
                type: "button",
                class: "orgteam-btn on",
                style: {"pointer-events":"auto"}
              }, "Share")
            ]),
            (_ctx.isAdmin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editChart()))
                  }, "Edit chart")
                ]))
              : _createCommentVNode("", true),
            (_ctx.rootNodes.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", {
                      class: "tree acct-flip",
                      style: _normalizeStyle({ zoom: _ctx.zoomLevels[_ctx.zoomIndex] })
                    }, [
                      _createElementVNode("ul", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rootNodes, (n) => {
                          return (_openBlock(), _createBlock(_component_accountability_chart_node, {
                            key: n.EmployeeID,
                            node: n
                          }, null, 8, ["node"]))
                        }), 128))
                      ])
                    ], 4)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                      type: "button",
                      title: "Zoom out",
                      disabled: _ctx.zoomIndex == 0,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.zoomIndex--))
                    }, [
                      _createVNode(_component_svg_icon, { icon: "zoomout" })
                    ], 8, _hoisted_8),
                    _createElementVNode("button", {
                      type: "button",
                      class: "acct-zoom-pct",
                      title: "Reset zoom",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.zoomIndex = _ctx.defaultZoomIndex))
                    }, _toDisplayString(Math.round(_ctx.zoomLevels[_ctx.zoomIndex] * 100)) + "%", 1),
                    _createElementVNode("button", {
                      type: "button",
                      title: "Zoom in",
                      disabled: _ctx.zoomIndex == _ctx.zoomLevels.length - 1,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.zoomIndex++))
                    }, [
                      _createVNode(_component_svg_icon, { icon: "zoomin" })
                    ], 8, _hoisted_9)
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[22] || (_cache[22] = _createTextVNode(" This chart doesn't have anyone in it yet. ", -1)),
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        _createElementVNode("a", {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editChart()))
                        }, "Add people"),
                        _cache[21] || (_cache[21] = _createTextVNode(".", -1))
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _cache[24] || (_cache[24] = _createTextVNode(" No accountability charts yet. ", -1)),
            (_ctx.isAdmin)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  _createElementVNode("a", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.newChart()))
                  }, "Create the first one"),
                  _cache[23] || (_cache[23] = _createTextVNode(".", -1))
                ]))
              : _createCommentVNode("", true)
          ]))
    ], 2),
    (_ctx.showShare)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                type: "button",
                class: "form-close-x",
                title: "Close",
                onClick: _cache[8] || (_cache[8] = () => { _ctx.showShare = false })
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("a", {
                onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.copyLink()), ["prevent"]))
              }, "Copy Link")
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("h3", null, "Email", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.shareData.email) = $event)),
              placeholder: "Email"
            }, null, 512), [
              [_vModelText, _ctx.shareData.email]
            ]),
            _cache[26] || (_cache[26] = _createElementVNode("h3", null, "Phone", -1)),
            _createVNode(_component_phone_input, {
              modelValue: _ctx.shareData.phone,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.shareData.phone) = $event)),
              placeholder: "Phone"
            }, null, 8, ["modelValue"]),
            _createElementVNode("input", {
              class: _normalizeClass(_ctx.sharing ? 'disable-button' : ''),
              type: "submit",
              value: "Send",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sendShare()))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEditChart)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                type: "button",
                class: "form-close-x",
                title: "Close",
                onClick: _cache[13] || (_cache[13] = () => { _ctx.showEditChart = false })
              }, "×")
            ]),
            _createElementVNode("h3", _hoisted_21, _toDisplayString(_ctx.editingChart.ID ? 'Edit chart' : 'New chart'), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "e.g. Production",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editingChart.Name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.editingChart.Name]
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", null, [
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "acct-editor-pane-label" }, "People in this chart", -1)),
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.addPersonID) = $event))
                  }, [
                    _cache[27] || (_cache[27] = _createElementVNode("option", { value: "" }, "Select someone to add…", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableEmployees, (e, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: i,
                        value: e.ID
                      }, [
                        _createTextVNode(_toDisplayString(e.Name), 1),
                        (_ctx.roleTitle(e))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" — " + _toDisplayString(_ctx.roleTitle(e)), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_24))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.addPersonID]
                  ]),
                  _createElementVNode("input", {
                    style: {"width":"auto"},
                    type: "submit",
                    value: "Add",
                    class: _normalizeClass(!_ctx.addPersonID ? 'disable-button' : ''),
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.addPerson()))
                  }, null, 2)
                ]),
                (_ctx.cycleEmployeeID)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, "⚠ " + _toDisplayString(_ctx.nameFor(_ctx.cycleEmployeeID)) + "'s \"reports to\" chain loops back to themself — fix it before saving.", 1))
                  : _createCommentVNode("", true),
                (_ctx.editingChart.nodes.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editingChart.nodes, (n) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: n.EmployeeID,
                          class: "acct-roster-row"
                        }, [
                          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.initialsFor(n.Name)), 1),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, _toDisplayString(n.Name), 1),
                            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.roleTitle(n)), 1)
                          ]),
                          _createElementVNode("select", {
                            class: _normalizeClass({ 'cycle-error': _ctx.cycleEmployeeID == n.EmployeeID }),
                            onChange: ($event: any) => (_ctx.setManager(n.EmployeeID, $event.target.value))
                          }, [
                            _createElementVNode("option", {
                              value: "",
                              selected: !n.ManagerEmployeeID
                            }, "— Top of chart —", 8, _hoisted_32),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherNodes(n.EmployeeID), (o, j) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: j,
                                value: o.EmployeeID,
                                selected: o.EmployeeID == n.ManagerEmployeeID
                              }, _toDisplayString(o.Name), 9, _hoisted_33))
                            }), 128))
                          ], 42, _hoisted_31),
                          _createElementVNode("button", {
                            type: "button",
                            class: "acct-remove-btn",
                            title: "Remove from chart",
                            onClick: ($event: any) => (_ctx.removeNode(n.EmployeeID))
                          }, "✕", 8, _hoisted_34)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_35, "No one's in this chart yet — add people above.")),
                (_ctx.editingChart.ID)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 3,
                      class: "acct-delete-link",
                      onClick: _cache[17] || (_cache[17] = () => { _ctx.showConfirmDelete = true })
                    }, "Delete this chart"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "acct-editor-pane-label" }, "Live preview — how everyone will see it", -1)),
                _createElementVNode("div", _hoisted_37, [
                  (_ctx.editorRootNodes.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("ul", _hoisted_39, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editorRootNodes, (n) => {
                            return (_openBlock(), _createBlock(_component_accountability_chart_node, {
                              key: n.EmployeeID,
                              node: n
                            }, null, 8, ["node"]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_40, "Nothing to preview yet."))
                ])
              ])
            ]),
            _createElementVNode("input", {
              style: {"margin-top":"25px"},
              class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
              type: "submit",
              value: "Save chart",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.saveChart()))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 2,
          onConfirm: _cache[19] || (_cache[19] = ($event: any) => (_ctx.deleteChart())),
          onCancel: _cache[20] || (_cache[20] = () => { _ctx.showConfirmDelete = false; }),
          msg: "Are you sure you would like to delete this chart?"
        }))
      : _createCommentVNode("", true)
  ]))
}